/*
 * fn: searchTypeahead
 *
 * Invokes the search API endpoint and maps results
 *
 */
import { type TypeaheadDynamicModeType } from '@/defs/input'
import { fetchApi } from '@/utils/requestUtil'

type Props = {
  mode?: TypeaheadDynamicModeType
  search: string
  signal: AbortSignal
}

type TypeaheadResponseType = {
  icon?: string
  id: string
  image?: string
  label: string
  url?: string
}

export const searchTypeahead = async ({ mode = 'all', search, signal }: Props) => {
  const params = new URLSearchParams()
  params.set('q', search)
  if (mode !== 'all') params.set('t', mode)
  const { data: results } = await fetchApi<TypeaheadResponseType[]>({
    base: 'api',
    options: { signal },
    path: `/typeahead?${params.toString()}`,
  })

  return results
}
